import React from 'react';
import { KuposInput } from '../../../../common';
import getIcons from '../../../functions/getIcons/getIcons';

function RutInput(props) {
  return (
    <div className="recharge-steps-outer">
      <div className="inputs">
        {!props.recipient ? (
          <div className="rut-input-share-balance">
            <div className="title bold-text font10">{props.t('PROFILE.RECIPIENT_RUT')}</div>
            <KuposInput
              placeholder={props.t('PROFILE.INSERT_RECIPIENT_RUT')}
              className="kupos-border font10"
              value={props.rut}
              onBlur={props.onBlur}
              onChange={val => {
                props.setRut(val);
                props.setRutError(null);
              }}
              error={props.rutError ? true : false}
              errorMessage={props.rutError ? props.t(props.rutError.message) : ''}
              disabled={props.recipient}
            />
            <div className="button-container font12">
              <button
                className="kupos-button"
                disabled={props.data.getCustomerInfoPending}
                onClick={props.getCustomerInfo}
                style={{
                  backgroundColor:
                    props.operator &&
                    props.operator.color_codes &&
                    props.operator.color_codes.button_color
                      ? props.operator.color_codes.button_color
                      : '',
                }}
              >
                {console.log(
                  'props.data.getCustomerInfoPending 1',
                  props.data.getCustomerInfoPending,
                )}
                {props.data.getCustomerInfoPending ? (
                  <div className="loader-cricle"></div>
                ) : (
                  <span>{props.t('PROFILE.SHARE')}</span>
                )}
              </button>
            </div>
          </div>
        ) : (
          <div className="recipient-info">
            <div className="kupos-card recipient-card font10">
              <div className="flex-row change">
                <span className="font11 bold-text flex1">{props.t('PROFILE.RECIPIENT')}</span>
                <div
                  className="capsule-menu"
                  onClick={() => props.setRecipient(null)}
                  style={{
                    backgroundColor:
                      props.operator &&
                      props.operator.color_codes &&
                      props.operator.color_codes.button_color
                        ? props.operator.color_codes.button_color
                        : '',
                  }}
                >
                  {props.t('PROFILE.CHANGE')}
                </div>
                <span className="heart-icon selected-contact-recharge-transfer">
                  <img
                    onClick={() => props.addRemoveFavourite(props.recipient)}
                    src={
                      // props.isFavourite()
                      //   ? '/static/images/icons/heart.png'
                      //   : '/static/images/icons/heart-empty.png'
                      props.isFavourite()
                        ? getIcons('heartOn', props.operator)
                        : getIcons('heartOff', props.operator)
                    }
                    alt=""
                  />
                </span>
              </div>
              <div className="recipient-name">
                {props.recipient.recipient_name} {props.recipient.last_name}
              </div>
              <div className="recipient-email">{props.recipient.recipient_email}</div>
              <div className="recipient-rut">RUT: {props.recipient.recipient_identity_val}</div>
            </div>
            <div className="amount-input">
              <div className="title bold-text font10">{props.t('PROFILE.AMOUNT_TO_TRANSFER')}</div>
              <KuposInput
                placeholder={props.t('PROFILE.INSERT_TRANSFER_AMOUNT')}
                className="kupos-border font10"
                value={props.amount}
                onBlur={() => {}}
                onChange={val => props.onAmountChange(val)}
                error={props.amountError ? true : false}
                errorMessage={props.amountError ? props.t(props.amountError.message) : ''}
              />
              <div className="button-container font12">
                <button
                  className="kupos-button"
                  disabled={props.data.getCustomerInfoPending}
                  onClick={props.onSubmitAmount}
                  style={{
                    backgroundColor:
                      props.operator &&
                      props.operator.color_codes &&
                      props.operator.color_codes.button_color
                        ? props.operator.color_codes.button_color
                        : '',
                  }}
                >
                  {console.log(
                    'props.data.getCustomerInfoPending',
                    props.data.getCustomerInfoPending,
                  )}
                  {props.data.getCustomerInfoPending ? (
                    <div className="loader-cricle"></div>
                  ) : (
                    <span>{props.t('PROFILE.SHARE')}</span>
                  )}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="steps">
        <div className="my-favourites kupos-card">
          <div className="font11 bold-text">{props.t('PROFILE.MY_FAV')}</div>
          <hr />
          <div className="favourist-list font10">
            {props.favourites &&
              props.favourites.map((item, key) => (
                <div className="favourite-item flex-row" key={key}>
                  <span onClick={() => props.selectfav(item)} className="name">
                    {item.name}
                  </span>
                  <span onClick={() => props.selectfav(item)} className="rut">
                    {item.identity_val}
                  </span>
                  <span className="heart-icon">
                    <img
                      onClick={() => props.addRemoveFavouriteList(item)}
                      src={
                        // !props.isFavouriteList(item)
                        //   ? '/static/images/icons/heart.png'
                        //   : '/static/images/icons/heart-empty.png'

                        !props.isFavouriteList(item)
                          ? getIcons('heartOn', props.operator)
                          : getIcons('heartOff', props.operator)
                      }
                      alt=""
                    />
                  </span>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default RutInput;



// WEBPACK FOOTER //
// ./src/features/themes/my-account/RechargeWalletKuposPayTransfer/components/RutInput.js